<template>
  <b-modal
    id="viewed_id"
    title="Documento visualizado por:"
    hide-footer
    centered
    size="lg"
  >
    <div>
      <div class="container-modern">
        <div class="table-section">
          <div class="table-card">
            <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
              <v-data-table
                :headers="headers"
                :items="docsUsers"
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [10, 50, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                class="modern-table"
                :no-data-text="'Nenhum documento encontrado'"
                :loading="loading"
                :loading-text="'Carregando documentos...'"
              >
                <template v-slot:[`item.user_name`]="{ item }">
                  <div class="user-cell">
                    <div class="user-avatar">
                      <img
                        v-if="item.user_photo"
                        :src="item.user_photo"
                        :alt="item.user_name"
                        class="user-photo"
                      />
                      <i v-else class="fas fa-user"></i>
                    </div>
                    <span class="user-name">{{ item.user_name }}</span>
                  </div>
                </template>

                <template v-slot:[`item.attempts`]="{ item }">
                  <span class="attempts-badge">
                    {{ item.attempts }} / {{ item.doc_attempts }}
                  </span>
                </template>

                <template v-slot:[`item.confirmation`]="{ item }">
                  <div v-if="item.confirmation == 1">
                    <span class="doc-status read">Documento lido</span>
                  </div>
                  <div v-if="item.confirmation == 0">
                    <span class="doc-status unread"
                      >Documento ainda não lido</span
                    >
                  </div>
                </template>
              </v-data-table>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from "../../services/api";

export default {
  name: "ViewedBy",

  data() {
    return {
      docsUsers: [],

      loading: false,

      headers: [
        {
          text: "Usuário",
          value: "user_name",
        },
        {
          text: "Quantidade de Visualizações",
          value: "attempts",
        },
        {
          text: "Marcado como lido",
          value: "confirmation",
        },
      ],
    };
  },

  props: {
    doc_id: [Number],
  },

  watch: {
    async doc_id() {
      await this.getDocs();
    },
  },

  methods: {
    async getDocs() {
      try {
        this.loading = true;

        const { doc_id } = this;

        const response = await api.get("/folder/user/read-doc/by-doc", {
          params: { doc_id },
        });

        const { docsUsers } = response.data;

        this.docsUsers = docsUsers;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.table-section,
.table-card {
  width: 100%;
}

.loading-overlay {
  border-radius: 16px;
}

/* Table Cell Styling */
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
}

/* Table Styling Override */
.modern-table {
  background: transparent !important;
}

/* Deep selector for Vuetify data table */
.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px 12px !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.doc-name {
  font-weight: 500;
  color: #1e293b;
  word-break: break-word;
}

.doc-status {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  margin: 0 0 0 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.doc-status.read {
  background: linear-gradient(135deg, #10b981 0%, #059669 80%);
}

.doc-status.unread {
  background: linear-gradient(135deg, #dd4747 0%, #d12e2e 80%);
}

.attempts-badge {
  display: inline-block;
  min-width: 54px;
  text-align: center;
  padding: 5px 14px;
  border-radius: 12px;
  background: #cfcfcf;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.07);
  letter-spacing: 0.5px;
}
</style>